/**
 * 全局配置管理
 */

// 环境类型
export type Environment = 'development' | 'production' | 'test';

// API配置
export const API_CONFIG = {
  // API基础URL（从环境变量读取）
  baseURL: process.env.REACT_APP_API_URL || 'https://xcx.shoudian.xin/api/v1',

  // 请求超时时间（毫秒）
  timeout: 120000, // 增加到2分钟

  // 是否启用请求日志
  enableRequestLog: process.env.REACT_APP_ENV === 'development',

  // 是否启用响应日志
  enableResponseLog: process.env.REACT_APP_ENV === 'development',
};

// 应用配置
export const APP_CONFIG = {
  // 应用名称
  appName: '甄来电小程序管理后台',
  
  // 应用版本
  version: '1.0.0',
  
  // 当前环境
  env: (process.env.REACT_APP_ENV as Environment) || 'development',
  
  // Token存储键名
  tokenKey: 'admin_token',
  refreshTokenKey: 'admin_refresh_token',
  userKey: 'admin_user',
  
  // 分页默认配置
  pagination: {
    defaultPageSize: 10,
    pageSizeOptions: ['10', '20', '50', '100'],
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total: number) => `共 ${total} 条`,
  },
  
  // 文件上传配置
  upload: {
    maxSize: 10 * 1024 * 1024, // 10MB
    allowedTypes: ['image/jpeg', 'image/png', 'image/gif', 'application/pdf'],
  },
};

// 获取当前环境
export const getEnvironment = (): Environment => {
  return APP_CONFIG.env;
};

// 判断是否为开发环境
export const isDevelopment = (): boolean => {
  return APP_CONFIG.env === 'development';
};

// 判断是否为生产环境
export const isProduction = (): boolean => {
  return APP_CONFIG.env === 'production';
};

// 获取API基础URL
export const getApiBaseUrl = (): string => {
  return API_CONFIG.baseURL;
};

// 获取完整的API地址
export const getApiUrl = (path: string): string => {
  const baseUrl = getApiBaseUrl();
  // 移除path开头的斜杠（如果有）
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  // 移除baseUrl末尾的斜杠（如果有）
  const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  return `${cleanBaseUrl}/${cleanPath}`;
};

export default {
  API_CONFIG,
  APP_CONFIG,
  getEnvironment,
  isDevelopment,
  isProduction,
  getApiBaseUrl,
  getApiUrl,
};